import { Injectable } from '@angular/core';
import {
  FieldAgentClient, WebTrackUser,
  SortParametersDirection, PagingParameters,
  SortParameters, BisTrackSettings, Customer, Branch, Right, UserPermissionPerYes
} from 'ep-bt-field-agent-proxy';
import { BistrackConfig, ErrorStatus, MainMenu, SearchPageNames } from 'ep-bt-controls';
import { EpToastService, EpToastType, IEpToastServiceModel, EpDialogService } from '@epicor/kinetic';
import { EpbtFaFilterService } from '../services/epbt-fa-filter.service';
import { EpbtFaSortService } from '../services/epbt-fa-sort.service';


declare var $: any;



@Injectable({
  providedIn: 'root'
})
export class EpbtFieldAgentService {

  //public trx: EpDataViewModelService = EpDataViewModelService.current;
  eventSubscriber: any;
  public bisTrackSetting: BisTrackSettings;
  public webTrackUser: WebTrackUser;
  public currentCustomer: Customer;
  public isDialogOpen: boolean = false;
  public currency: string = "$";
  public bisTrackBranches: Branch[];
  public isLoad: boolean = false;
  public isMobile: boolean;

  //Toast message code start
  tstConfig: IEpToastServiceModel = {
    newestOnTop: true,
    progressBar: true,
    progressAnimation: 'decreasing',
    timeOut: 3000,
    extendedTimeOut: 3000,
    positionClass: 'toast-top-right',
    closeButton: true,
    enableHtml: true,
    tapToDismiss: true,
    preventDuplicates: true,
    resetTimeoutOnDuplicate: false,
    disableTimeOut: false,
    maxOpened: 0,
    autoDismiss: false,
    easeTime: 30,
    toastClass: 'toast'
  };

  toastOpt = {
    message: '',
    title: '',
    toastConfig: this.tstConfig,
    toastType: EpToastType.Success
  };

  //Toast message code end

  constructor(private client: FieldAgentClient, private config: BistrackConfig,
    public epToast: EpToastService, private epDialogService: EpDialogService,
    private filterService: EpbtFaFilterService, private sortService: EpbtFaSortService) {
    // this.getBisTrackSetting((bistrackSettings: any) => {
    // });
    // this.getWebTrackUser((webTrackUser: any) => {
    // });
  }

  getBisTrackSetting(subscribe: (bisTrackSetting: any) => void) {
    if (this.bisTrackSetting) {
      subscribe(this.bisTrackSetting);
    }
    else {
      this.client.getBisTrackSettings().subscribe(bisTrackSetting => {
        this.bisTrackSetting = bisTrackSetting;
        this.config.setwebTrackInstanceID(bisTrackSetting.webTrackInstanceID);
        this.bisTrackSetting = bisTrackSetting;
        this.currency = bisTrackSetting.baseCurrency.symbol;
        subscribe(this.bisTrackSetting);
      });
    }
  }

  getWebTrackUser(subscribe: (webTrackUser: any) => void) {
    if (this.webTrackUser) {
      subscribe(this.webTrackUser);
    }
    else {
      this.client.getUser(this.config.getLoggedinUserName(), this.config.getwebTrackInstanceID()).subscribe(webTrackUser => {
        this.webTrackUser = webTrackUser;
        subscribe(this.webTrackUser);
      });
    }
  }

  getCurrentCustomer(customerId: number, subscribe: (customer: any) => void) {
    if (this.currentCustomer) {
      subscribe(this.currentCustomer);
    }
    else {
      this.client.getCustomer(customerId).subscribe(res => {
        this.currentCustomer = res;
        subscribe(this.currentCustomer);
      });
    }
  }

  //Paging
  paging(index: number, count: number): PagingParameters {
    var paging = new PagingParameters();
    paging.index = index;
    paging.count = count;
    return paging;
  }

  //Sorting 
  sorting(sortColumn: string, direction: string): SortParameters {
    var sorting = new SortParameters();
    sorting.sortColumn = sortColumn;
    sorting.direction = SortParametersDirection.Ascending == direction ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
    return sorting;
  }

  //Dialog methods start
  displayToastMessage(title: string, message: string, type: string) {
    this.toastOpt.title = title;
    this.toastOpt.message = message;
    if (type == ErrorStatus.Success)
      this.toastOpt.toastType = EpToastType.Success;
    else if (type == ErrorStatus.Error)
      this.toastOpt.toastType = EpToastType.Error;
    else if (type == ErrorStatus.Warning)
      this.toastOpt.toastType = EpToastType.Warning;
    else if (type == ErrorStatus.Info)
      this.toastOpt.toastType = EpToastType.Info;
    this.epToast.show(this.toastOpt);
  }

  //Dialog methods end

  openOrCloseProcessDialog() {
    if (!this.isDialogOpen) {
      this.isDialogOpen = true;
      this.epDialogService.progress({ message: 'Loading', description: 'Please wait...' });
    }
    else {
      this.isDialogOpen = false;
      setTimeout(() => {
        this.epDialogService.close();
      }, 500);
    }
  }

  closeDialog() {

  }

  combiteDateAndTime(date: Date, time: Date): Date {
    let finalDate: Date;
    if (date && time) {
      finalDate = date;
      finalDate.setHours(time.getHours());
      finalDate.setMinutes(time.getMinutes());
    }
    else if (!date && time) {
      finalDate = new Date();
      finalDate.setHours(time.getHours());
      finalDate.setMinutes(time.getMinutes());
      // finalDate.setTime(time.getTime());
    }
    else if (date && !time) {
      finalDate = date;
      finalDate.setHours(new Date().getHours());
      finalDate.setMinutes(new Date().getMinutes());
    }
    else {
      finalDate = null;
    }
    return this.convertToUtc(finalDate);
  }

  convertToUtc(date: Date): Date {
    const offSet = date.getTimezoneOffset();
    // var utcDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(),
    //   date.getHours(), date.getMinutes() + (-1 * offSet), date.getSeconds());

    // var tempDate = new Date(date.toUTCString());
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(),
      date.getHours(), date.getMinutes() + (-1 * offSet), date.getSeconds());
  }

  public getHeight(): number {
    var height = $(window).outerHeight() - 80;
    var width = parseInt($('body').width());
    if (width > 250 && width < 1023) {
      //mobile and ipad
      return 400;
    }
    return height;
    // if (width > 1024 && width < 1366) {
    //   //mobile and ipad
    //   return 610;
    // }
    // else  if (width > 768 && width < 1023) {
    //   //mobile and ipad
    //   return 560;
    // }
    // else  if (width > 641 && width < 767) {
    //   //mobile and ipad
    //   return 237;
    // }
    // else  if (width > 575 && width < 640) {
    //   //mobile
    //   return 230;
    // }
    // else  if (width > 481 && width < 574) {
    //   //mobile
    //   return 185;
    // }
    // else  if (width > 375 && width < 480) {
    //   //mobile
    //   return 480;
    // }
    // else  if (width > 320 && width < 374) {
    //   //mobile
    //   return 485;
    // }
    // return height;
  }
  checkAddPermissions(permission, subscribe: (flag: any) => void, viewPermission: string = null) {
    let flag: boolean = false;
    this.getWebTrackUser((webTrackUser: any) => {
      if (webTrackUser) {
        if (viewPermission == null) {
          let item = webTrackUser.rights.find(r => r.name == permission);
          flag = item ? true : false;
        }
        else {
          let item = webTrackUser.rights.find(r => r.name == viewPermission);
          if (item) {
            let item1 = webTrackUser.rights.find(r => r.name == permission);
            flag = item1 ? true : false;
          }
          else
            flag = false;
        }
      }
      else
        flag = false;
      subscribe(flag);
    });
  }

  checkDisplayPermissions(permission, subscribe: (flag: any) => void) {
    let flag: boolean = false;
    this.getWebTrackUser((webTrackUser: any) => {
      if (webTrackUser) {
        let item: Right = webTrackUser.rights.find(r => r.name == permission);
        if (item) {
          flag = item.permission.perYes == UserPermissionPerYes.PleGranted ? true : false;
        }
        else {
          flag = false;
        }
      }
      else
        flag = false;
      subscribe(flag);
    });
  }

  setDefaultValuesFromMenuNavigation(menuName) {
    switch (menuName) {
      case MainMenu.Contacts:
        {
          this.sortService.setDefaultSortValues(SearchPageNames.DashboardContactSearch);
          break;
        }
      case MainMenu.Opportunities:
        {
          this.sortService.setDefaultSortValues(SearchPageNames.DashboardOpportunitySearch);
          this.filterService.setDefaultFilterValues(SearchPageNames.DashboardOpportunitySearch);
          break;
        }
      case MainMenu.Customers:
        {
          this.sortService.setDefaultSortValues(SearchPageNames.CustomerSearch);
          break;
        }
      case MainMenu.Notepad:
        {
          this.sortService.setDefaultSortValues(SearchPageNames.DashboardNotepadSearch);
          this.filterService.setDefaultFilterValues(SearchPageNames.DashboardNotepadSearch);
          break;
        }
      case MainMenu.Products:
        {
          this.sortService.setDefaultSortValues(SearchPageNames.ProductSearch);
          break;
        }
      case MainMenu.Calendar:
        {
          break;
        }
      case MainMenu.Documents:
        {
          this.sortService.setDefaultSortValues(SearchPageNames.DashboardDocumentsSearch);
          this.filterService.setDefaultFilterValues(SearchPageNames.DashboardDocumentsSearch);
          break;
        }
      case MainMenu.QuickOrder:
        {
          break;
        }
      case MainMenu.QuickPurchase:
        {
          break;
        }
      case MainMenu.QuickTransfer:
        {
          break;
        }
      case MainMenu.Labels:
        {
          break;
        }
      case MainMenu.BinLocations:
        {
          break;
        }
      case MainMenu.CompetitorPricing:
        {
          break;
        }
      default:
        {
          break;
        }
    }
  }

}
